import { CHERRY_DEV } from '../CherrySoftware/cherryDevBrand';

export { CHERRY_DEV };

/** Paleta travel: océano / lagoon / arena / atardecer */
export const GUOMEI = {
  ocean: '#0B3D4A',
  oceanDeep: '#062A33',
  lagoon: '#1A7A8C',
  lagoonSoft: '#2A9BB0',
  sand: '#F3EDE3',
  sandDeep: '#E8DFD0',
  sunset: '#E07A3D',
  sunsetSoft: '#F0A06A',
  ink: '#142028',
  inkMuted: '#4A5C66',
  white: '#FFFFFF',
};

const BRAND_NAME = 'cherryDev';
const CLIENT_NAME = 'Guomei Latam';
const CLIENT_CONTACT = 'Susana';

export const WHATSAPP_PHONE =
  (typeof process !== 'undefined' &&
    process.env &&
    process.env.REACT_APP_CHERRY_SOFTWARE_WHATSAPP_PHONE) ||
  '';

export const WHATSAPP_WEB_DEFAULT = `Hola ${BRAND_NAME}, soy ${CLIENT_CONTACT} de ${CLIENT_NAME}. Revisé la propuesta de la plataforma web y envío el comprobante + link de Drive (compartido con karolscript@gmail.com).`;

export const WHATSAPP_ADS_DEFAULT = `Hola ${BRAND_NAME}, soy ${CLIENT_CONTACT} de ${CLIENT_NAME}. Quiero cotizar el plan de redes sociales para Guomei Latam.`;

export const buildAdsPlanWhatsApp = (planName) =>
  `Hola ${BRAND_NAME}, soy ${CLIENT_CONTACT} de ${CLIENT_NAME}. Quiero el plan ${planName} de redes sociales. ¿Me confirman alcance, inicio y forma de pago?`;

export const PAGE_TITLE = `${BRAND_NAME} × ${CLIENT_NAME} | Propuesta web y redes`;
export const PAGE_DESCRIPTION =
  'Propuesta cherryDev para Guomei Latam: plataforma e-commerce de viajes ($130) y paquetes mensuales de redes sociales. Registro de pagos, cotización WhatsApp y Ads aparte.';

export const WEB_PAGE_TITLE = `${BRAND_NAME} × ${CLIENT_NAME} | Plataforma de viajes`;
export const WEB_PAGE_DESCRIPTION =
  'Propuesta cherryDev para Guomei Latam: plataforma administrable de viajes con módulos dinámicos, registro de pagos y status, cotización por WhatsApp, dominio y hosting. Inversión total $130 USD.';

export const ADS_PAGE_TITLE = `${BRAND_NAME} × ${CLIENT_NAME} | Redes sociales`;
export const ADS_PAGE_DESCRIPTION =
  'Propuesta de manejo de redes para Guomei Latam: paquetes mensuales Esencial, Crecimiento e Integral. Pauta Ads aparte.';

export const WEB_HERO_IMAGE =
  'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=1920&q=80';

export const ADS_HERO_IMAGE =
  'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?auto=format&fit=crop&w=1920&q=80';

export const LINKS = {
  web: '/propuesta/guomei#ecommerce',
  ads: '/propuesta/guomei#publicidad',
};

export const webHero = {
  brand: BRAND_NAME,
  clientName: CLIENT_NAME,
  clientContact: CLIENT_CONTACT,
  overline: 'Propuesta formal · Plataforma de viajes',
  title: 'Tu plataforma de viajes, 100% administrable.',
  subtitle:
    'Control total de destinos, cruceros, boletos y visados: publicas ofertas, cambias precios y activas módulos cuando quieras. Incluye registro de pagos para consolidar cobros y llevar el status de cada operación, con cotizaciones directas a tu WhatsApp.',
  cta: 'Ver estructura e inversión',
  congrats: `Claro que sí, ${CLIENT_CONTACT}.`,
};

export const webStructure = {
  overline: 'Plataforma',
  title: 'Estructura de tu sistema de viajes',
  subtitle:
    'Diseño profesional con la marca Guomei Latam, módulos dinámicos y control de pagos para vender, cotizar y consolidar cobros sin fricción.',
  modules: [
    {
      id: 'header',
      title: 'Diseño y cabecera profesional',
      text:
        'Identidad Guomei Latam con banners atractivos de destinos y cruceros para abrir la conversación visual desde el primer scroll.',
    },
    {
      id: 'boletos',
      title: 'Boletos y paquetes',
      text:
        'Módulo dinámico para ofertas nacionales e internacionales: activas, desactivas y destacas según disponibilidad.',
    },
    {
      id: 'cruceros',
      title: 'Cruceros',
      text:
        'Espacio para experiencias destacadas, temporadas y promociones de cruceros con cambio de precios cuando tú quieras.',
    },
    {
      id: 'aerea',
      title: 'Boletería aérea',
      text:
        'Gestión de pasajes con presentación clara y botones de cotización directa a WhatsApp.',
    },
    {
      id: 'visados',
      title: 'Trámite de visados',
      text:
        'Asesoría y gestión de documentos: módulo dedicado para transmitir confianza y captar consultas.',
    },
    {
      id: 'pagos',
      title: 'Registro y gestión de pagos',
      text:
        'Panel para recibir y consolidar la información de pagos de tus clientes: método, monto, referencia/comprobante, cliente vinculado y status (pendiente, verificado, rechazado o completado). Así llevas el control de cobros en un solo lugar, sin perseguir datos sueltos por WhatsApp.',
    },
    {
      id: 'promos',
      title: 'Gestión dinámica y promociones',
      text:
        'Cada módulo es administrable: ofertas de temporada, precios y paquetes destacados sin depender de un desarrollador.',
    },
  ],
};

export const webInvestment = {
  overline: 'Inversión',
  title: 'Plataforma completa, precio claro',
  subtitle: 'Te dejamos todo montado y listo para operar.',
  lines: [
    {
      id: 'platform',
      label: 'Sistema administrable / tienda online (incluye registro de pagos)',
      amount: 120,
    },
    { id: 'hosting', label: 'Dominio (.com) y hosting (1er año)', amount: 10 },
  ],
  total: 130,
  currency: 'USD',
  note: 'Sin cobros sorpresa en el primer año de dominio y hosting.',
};

export const payment = {
  overline: 'Formalización',
  title: 'Métodos de pago',
  subtitle: 'Toca Copiar en el dato que necesites. Queda listo en el portapapeles.',
  methods: [
    {
      id: 'zelle',
      name: 'Zelle',
      fields: [{ label: 'Correo', value: 'loreanaquino53@gmail.com' }],
    },
    {
      id: 'binance',
      name: 'Binance',
      fields: [{ label: 'Correo / Pay ID', value: 'karolyntno@gmail.com' }],
    },
    {
      id: 'zinli',
      name: 'Zinli',
      fields: [{ label: 'Correo', value: 'karolyntno@gmail.com' }],
    },
    {
      id: 'pagomovil',
      name: 'Pago Móvil (Bs a tasa promedio)',
      fields: [
        {
          label: 'Datos completos',
          value: 'Karolyn Méndez · CI 166444576 · 04123964576 · Banesco',
        },
      ],
    },
  ],
};

export const webNextSteps = {
  overline: 'Siguientes pasos',
  title: 'Así formalizamos y arrancamos',
  subtitle: 'Pago, material en Drive y Guomei Latam entra en producción.',
  driveEmail: 'karolscript@gmail.com',
  steps: [
    {
      id: 'pago',
      n: '01',
      title: 'Pago y comprobante',
      text: 'Realiza el pago y envíanos el comprobante por WhatsApp para bloquear tu cupo de inmediato.',
    },
    {
      id: 'drive',
      n: '02',
      title: 'Sube todo el material a Google Drive',
      text:
        'Crea una carpeta con el material de Guomei Latam, compártela con karolscript@gmail.com y pásanos el link por WhatsApp.',
      materials: [
        'Logo en alta calidad (PNG/SVG preferible)',
        'Manual de marca, si lo tienes (colores, tipografías, usos del logo)',
        'Fotos de destinos, cruceros y experiencias',
        'Listado inicial de servicios/paquetes con precios o rangos',
        'Métodos de cobro que aceptas (Zelle, transferencia, Pago Móvil, etc.) para el registro de pagos',
        'Textos de la marca y promesa de servicio',
        'WhatsApp de cotizaciones, teléfono, correo y redes',
        'Ubicación / horarios si aplican atención presencial',
        'Banners o promociones de temporada, si ya los tienes',
      ],
    },
    {
      id: 'arranque',
      n: '03',
      title: 'Confirmación y arranque',
      text: 'Con el pago y el link de Drive empezamos a montar la plataforma.',
    },
  ],
  cta: 'Enviar comprobante por WhatsApp',
  copyright: `© ${new Date().getFullYear()} ${BRAND_NAME} · Propuesta para ${CLIENT_NAME}`,
};

export const adsHero = {
  brand: BRAND_NAME,
  clientName: CLIENT_NAME,
  overline: 'Redes para viajar y cotizar',
  title: 'Inspiran. Cotizan. Convierten.',
  subtitle: 'Planes mensuales claros. Respuesta a mensajes incluida. Tráfico hacia tu web y WhatsApp.',
  cta: 'Ver planes',
};

export const adsFactors = {
  overline: 'En pocas palabras',
  title: 'Qué hace subir o bajar el plan',
  items: [
    { id: 'platforms', title: 'Cuántas redes' },
    { id: 'volume', title: 'Foto vs video' },
    { id: 'community', title: 'Respuesta a mensajes' },
    { id: 'assets', title: 'Quién da el material' },
    { id: 'ads', title: 'Ads aparte' },
  ],
};

export const adsPackages = {
  overline: 'Planes',
  title: 'Tres ritmos. Un objetivo: cotizaciones.',
  subtitle: 'Todos incluyen respuesta a mensajes en horario comercial.',
  plans: [
    {
      id: 'esencial',
      name: 'Esencial',
      tag: 'Presencia',
      price: 140,
      priceNote: '/mes',
      featured: false,
      focus: 'Marca activa e inspiración de viaje.',
      cta: 'Quiero Esencial',
      stats: [
        { label: 'Redes', value: 'IG + FB' },
        { label: 'Pubs', value: '12/mes' },
        { label: 'Ritmo', value: '3/sem' },
      ],
      features: [
        'Carruseles, fotos y Reels cortos',
        'Copy a WhatsApp o web',
        'Hashtags turismo + programación',
        'Respuesta a mensajes incluida',
      ],
    },
    {
      id: 'pro',
      name: 'Pro',
      tag: 'Conversión',
      price: 280,
      priceNote: '/mes',
      featured: true,
      badge: 'Ideal',
      focus: 'Más video y prospectos a WhatsApp.',
      cta: 'Quiero Pro',
      stats: [
        { label: 'Redes', value: 'IG · TT · FB' },
        { label: 'Pubs', value: '16–20/mes' },
        { label: 'Stories', value: '3–5/sem' },
      ],
      features: [
        'Reels y TikToks de destinos/cruceros',
        'Historias con ofertas y web',
        'DMs → WhatsApp comercial',
        'Reporte: alcance y clics a la web',
      ],
    },
    {
      id: 'integral',
      name: 'Integral',
      tag: 'Temporada alta',
      price: 390,
      priceNote: '/mes',
      featured: false,
      focus: 'Máxima presencia + seguimiento.',
      cta: 'Quiero Integral',
      stats: [
        { label: 'Redes', value: 'Hasta 4' },
        { label: 'Base', value: 'Todo Pro' },
        { label: 'Plus', value: 'Reunión/mes' },
      ],
      features: [
        'Más video y storytelling',
        'Calendario por temporada',
        'CM activo + reporte ampliado',
        'Ads Meta/TikTok aparte',
      ],
    },
  ],
};

export const adsNotes = {
  overline: 'Importante',
  title: 'Tres reglas claras',
  items: [
    {
      id: 'sinergia',
      title: 'Redes + web',
      text: 'Las redes abren el deseo; tu catálogo online cierra la cotización.',
    },
    {
      id: 'material',
      title: 'Material',
      text: 'Si aportas fotos/videos, el fee se mantiene. Producción nuestra se cotiza aparte.',
    },
    {
      id: 'pauta',
      title: 'Ads',
      text: 'La inversión la pagas a Meta/TikTok. Gestión: +$100–150/mes o % del spend.',
    },
  ],
};

export const adsFinal = {
  overline: 'Siguiente paso',
  title: '¿Arrancamos con qué plan?',
  subtitle: 'WhatsApp para confirmar inicio. La web potencia todo.',
  cta: 'Hablar por WhatsApp',
  webCta: 'Ver e-commerce $130',
  copyright: `© ${new Date().getFullYear()} ${BRAND_NAME} · Redes para ${CLIENT_NAME}`,
};
